import { render, staticRenderFns } from "./SnippetCategory.vue?vue&type=template&id=d56247ee&"
import script from "./SnippetCategory.vue?vue&type=script&lang=js&"
export * from "./SnippetCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports